import {
  GET_MODULES,
  GET_MODULES_SUCCESS,
  GET_MODULES_FAIL,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  modules: [],
  hasFetched: false, // true only after first successful/failed response
}

const sidebar = (state = initialState, action) => {
  switch (action.type) {
    case GET_MODULES:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_MODULES_SUCCESS:
      state = {
        ...state,
        loading: false,
        modules: action.payload,
        hasFetched: true,
        error: "",
      }
      break
    case GET_MODULES_FAIL:
      state = {
        ...state,
        loading: false,
        hasFetched: true,
        error: action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default sidebar
